<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>PM SURYA GHAR MUFT BIJLI YOJANA</h2>
            <ul>
                <li>
                    <a routerLink="/">Home</a>
                </li>
                <li>PM SURYA GHAR MUFT BIJLI YOJANA</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->
<section class="solar-subsidy-hero">
    <div class="container">
        <div class="solar-subsidy-hero-content">
            <div class="solar-subsidy-hero-text">
                <span class="section-tag">
                    PM SURYA GHAR MUFT BIJLI YOJANA
                </span>
                <h1>
                    Get Up to
                    <span>₹78,000</span>
                    Solar Subsidy
                </h1>
                <p>
                    Make rooftop solar more affordable with the government
                    subsidy available for eligible residential solar
                    installations under PM Surya Ghar Muft Bijli Yojana.
                </p>
                <div class="solar-subsidy-hero-buttons">
                    <a routerLink="/contact" class="btn btn-primary">
                        Check Your Subsidy
                        <i class="flaticon-right"></i>
                    </a>
                    <a href="javascript:void(0)" class="solar-subsidy-link" (click)="scrollToCalculator()">
                        Calculate Solar Savings
                        <i class="bx bx-right-arrow-alt"></i>
                    </a>
                </div>

                <div class="solar-subsidy-trust">
                    <div>
                        <i class="bx bx-check-circle"></i>
                        <span>Up to ₹78,000 Subsidy</span>
                    </div>
                    <div>
                        <i class="bx bx-home"></i>
                        <span>Residential Rooftop Solar</span>
                    </div>
                </div>
            </div>

            <div class="solar-subsidy-hero-visual">
                <div class="solar-subsidy-circle">
                    <div class="solar-subsidy-sun">
                        <i class="bx bx-sun"></i>
                    </div>
                </div>
                <div class="solar-subsidy-house">
                    <i class="bx bx-home-alt-2"></i>
                </div>

                <div class="subsidy-floating-card subsidy-card-top">
                    <span>Maximum Subsidy</span>
                    <strong>₹78,000</strong>
                </div>
                <div class="subsidy-floating-card subsidy-card-bottom">
                    <i class="bx bx-rupee"></i>
                    <div>
                        <strong>Save More</strong>
                        <span>with Solar Subsidy</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- =========================
     02. SUBSIDY AMOUNT
========================= -->
<section class="solar-subsidy-amount ptb-100">
    <div class="container">
        <div class="section-title">
            <span>Government Solar Subsidy</span>
            <h2>How Much Solar Subsidy Can You Get?</h2>
            <p>
                Eligible residential rooftop solar systems can receive central
                financial assistance based on the installed system capacity.
            </p>
        </div>

        <div class="subsidy-amount-grid">
            <!-- 1 KW -->
            <div class="subsidy-amount-card">
                <div class="subsidy-card-icon">
                    <i class="bx bx-sun"></i>
                </div>
                <span class="subsidy-capacity"> 1 kW Solar System </span>
                <h3>₹30,000</h3>
                <p>
                    Central subsidy available for an eligible 1 kW residential
                    rooftop solar system.
                </p>
            </div>

            <!-- 2 KW -->
            <div class="subsidy-amount-card">
                <div class="subsidy-card-icon">
                    <i class="bx bx-sun"></i>
                </div>
                <span class="subsidy-capacity"> 2 kW Solar System </span>
                <h3>₹60,000</h3>
                <p>
                    Central subsidy available for an eligible 2 kW residential
                    rooftop solar system.
                </p>
            </div>

            <!-- 3 KW+ -->
            <div class="subsidy-amount-card featured">
                <div class="subsidy-card-badge">Maximum Benefit</div>
                <div class="subsidy-card-icon">
                    <i class="bx bx-sun"></i>
                </div>
                <span class="subsidy-capacity"> 3 kW & Above </span>
                <h3>₹78,000</h3>
                <p>
                    Maximum central subsidy under the stated subsidy structure,
                    even for systems larger than 3 kW.
                </p>
            </div>
        </div>

        <div class="subsidy-note">
            <i class="bx bx-info-circle"></i>
            <p>
                The central subsidy is capped at ₹78,000 for systems of 3 kW or
                above.
            </p>
        </div>
    </div>
</section>

<!-- =========================
     03. PM SURYA GHAR + ELIGIBILITY
========================= -->
<section class="solar-subsidy-about ptb-100 bg-f7f9fc">
    <div class="container">
        <div class="solar-subsidy-about-grid">
            <!-- LEFT -->
            <div class="solar-subsidy-about-content">
                <span class="section-tag"> PM SURYA GHAR </span>

                <h2>Making Rooftop Solar More Affordable</h2>

                <p>
                    PM Surya Ghar Muft Bijli Yojana is a government initiative
                    designed to support eligible households in installing
                    grid-connected rooftop solar systems.
                </p>

                <p>
                    Under the scheme, eligible homeowners can receive financial
                    assistance based on the capacity of their rooftop solar
                    installation.
                </p>

                <div class="subsidy-info-box">
                    <div class="subsidy-info-icon">
                        <i class="bx bx-rupee"></i>
                    </div>

                    <div>
                        <strong>Up to ₹78,000</strong>
                        <span> Central subsidy for eligible systems </span>
                    </div>
                </div>
            </div>

            <!-- RIGHT -->
            <div class="solar-eligibility-card">
                <div class="eligibility-card-header">
                    <div class="eligibility-icon">
                        <i class="bx bx-check-shield"></i>
                    </div>

                    <div>
                        <span>Eligibility</span>
                        <h3>Are You Eligible?</h3>
                    </div>
                </div>

                <div class="eligibility-list">
                    <div class="eligibility-item">
                        <i class="bx bx-check"></i>
                        <span> Residential property located in India </span>
                    </div>

                    <div class="eligibility-item">
                        <i class="bx bx-check"></i>
                        <span>
                            Eligible grid-connected residential electricity
                            connection
                        </span>
                    </div>

                    <div class="eligibility-item">
                        <i class="bx bx-check"></i>
                        <span> Suitable shadow-free rooftop space </span>
                    </div>

                    <div class="eligibility-item">
                        <i class="bx bx-check"></i>
                        <span> Aadhaar-linked eligible bank account </span>
                    </div>
                </div>

                <div class="eligibility-footer">
                    <i class="bx bx-info-circle"></i>

                    <p>
                        Scheme eligibility and requirements should be verified
                        before applying.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- =========================
     04. HOW SUBSIDY WORKS
========================= -->
<section class="solar-subsidy-process ptb-100">
    <div class="container">
        <div class="section-title">
            <span>Simple Solar Subsidy Process</span>

            <h2>How Does the Solar Subsidy Work?</h2>

            <p>
                From application to commissioning, the subsidy process follows a
                structured sequence for eligible installations.
            </p>
        </div>

        <div class="subsidy-process">
            <!-- STEP 01 -->
            <div class="subsidy-process-step">
                <div class="process-number">01</div>

                <div class="process-icon">
                    <i class="bx bx-edit"></i>
                </div>

                <h3>Apply</h3>

                <p>
                    Submit your application through the applicable government
                    portal and provide the required details.
                </p>
            </div>

            <!-- STEP 02 -->
            <div class="subsidy-process-step">
                <div class="process-number">02</div>

                <div class="process-icon">
                    <i class="bx bx-sun"></i>
                </div>

                <h3>Install</h3>

                <p>
                    Install the eligible grid-connected rooftop solar system
                    through an approved or empanelled vendor.
                </p>
            </div>

            <!-- STEP 03 -->
            <div class="subsidy-process-step">
                <div class="process-number">03</div>

                <div class="process-icon">
                    <i class="bx bx-check-shield"></i>
                </div>

                <h3>DISCOM Verification</h3>

                <p>
                    The installation is inspected and commissioned according to
                    applicable requirements.
                </p>
            </div>

            <!-- STEP 04 -->
            <div class="subsidy-process-step">
                <div class="process-number">04</div>

                <div class="process-icon">
                    <i class="bx bx-credit-card"></i>
                </div>

                <h3>Receive Subsidy</h3>

                <p>
                    After successful verification and commissioning, the
                    eligible subsidy is transferred through DBT.
                </p>
            </div>
        </div>
    </div>
</section>

<div id="solar-calculator">
    <app-solar-calculator></app-solar-calculator>
</div>
<!-- =========================
     05. WHY GO SOLAR
========================= -->
<section class="solar-subsidy-benefits ptb-100 bg-f7f9fc">
    <div class="container">
        <div class="section-title">
            <span>Benefits of Going Solar</span>

            <h2>More Than Just a Government Subsidy</h2>

            <p>
                Rooftop solar can help reduce electricity costs while supporting
                cleaner and more efficient energy use.
            </p>
        </div>

        <div class="subsidy-benefits-grid">
            <div class="subsidy-benefit-card">
                <div class="benefit-icon">
                    <i class="bx bx-rupee"></i>
                </div>

                <h3>Lower Initial Cost</h3>

                <p>
                    Eligible government subsidy can help reduce the effective
                    cost of your rooftop solar investment.
                </p>
            </div>

            <div class="subsidy-benefit-card">
                <div class="benefit-icon">
                    <i class="bx bx-bulb"></i>
                </div>

                <h3>Lower Electricity Bills</h3>

                <p>
                    Generate solar electricity for your home's daily energy
                    requirements and reduce grid dependence.
                </p>
            </div>

            <div class="subsidy-benefit-card">
                <div class="benefit-icon">
                    <i class="bx bx-leaf"></i>
                </div>

                <h3>Clean Energy</h3>

                <p>
                    Use renewable solar energy and move towards a cleaner and
                    more sustainable energy future.
                </p>
            </div>

            <div class="subsidy-benefit-card">
                <div class="benefit-icon">
                    <i class="bx bx-line-chart"></i>
                </div>

                <h3>Long-Term Savings</h3>

                <p>
                    A properly maintained rooftop solar system can continue
                    generating clean electricity for many years.
                </p>
            </div>
        </div>
    </div>
</section>

<app-faq></app-faq>